import React, { memo } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";

import CONSTANTS from "./../../../common/constants";

import ActionBar from "./ActionBars/ActionBar";
import Divider from "../../Common/Divider";
import GeneralDetails from "./Details/GeneralDetails";
import DisplaySwitcher from "./Sections/DisplaySwitcher";

const selectCustomer = createSelector(
	state => state.customers,
	(_, id) => id,
	(customers, id) => {
		return customers
			? customers.find(customer => {
				return customer.uuid.toString() === id;
			})
			: null;
	});

const Customer = memo(({ match }) => {
	const customer = useSelector(state =>
		selectCustomer(state, match.params.id)
	);

	return customer ? (
		<>
			<ActionBar customer={customer} />
			<Divider />
			<GeneralDetails customer={customer} />
			<Divider />
			<DisplaySwitcher customer={customer} />
		</>
	) : (
			<Redirect to={`${CONSTANTS.ROUTE.CUSTOMERS}`} />
		);
});
Customer.displayName = `Customer`;
Customer.propTypes = {
	match: PropTypes.object
};

export default Customer;
